import { render, staticRenderFns } from "./PreviousContractImportModal.vue?vue&type=template&id=12ca3494"
import script from "./PreviousContractImportModal.vue?vue&type=script&lang=js"
export * from "./PreviousContractImportModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports